module.exports = __webpack_public_path__ + "img/universe.0a785375.png";